module.exports = __webpack_public_path__ + "img/14.a90cb91f.jpg";